export interface GetMigrationStatus {
  migrated: boolean
}
